import { createFileRoute, redirect } from '@tanstack/react-router';

// FSU shell unification: the pre-FSU /audit-log URL is retired. Audit log
// lives under the new Settings sub-nav. Existing bookmarks redirect.
export const Route = createFileRoute('/admin/finance/audit-log')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/finance/settings/audit-log' });
  },
});
